import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
const STEPS = [
    { Icon: PersonAddIcon, title: 'Sign up & connect', desc: 'Create your Dare Drop account and connect the channel you stream on.' },
    { Icon: SportsEsportsIcon, title: 'Accept a dare', desc: 'Pick a dare from this drop and stream the game to your community.' },
    { Icon: CardGiftcardIcon, title: 'Complete & earn', desc: 'Finish the dare to unlock rewards for you and keys for your viewers.' },
];
export const DropHowItWorksSection = () => (<section id="howto" className="scroll-mt-40 px-4 py-12 sm:px-6 lg:px-8">
		<div className="mx-auto max-w-7xl">
			<h2 className="font-display text-2xl font-bold text-foreground sm:text-3xl">How It Works</h2>
			<div className="mt-6 grid gap-4 sm:grid-cols-3">
				{STEPS.map((step, index) => {
        const { Icon } = step;
        return (<div key={step.title} className="rounded-2xl border border-solid border-white/[0.06] bg-card p-5">
							<div className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-brand text-white">
								<Icon sx={{ fontSize: 18 }}/>
							</div>
							<h3 className="mt-3 font-display text-sm font-bold text-foreground">{index + 1}. {step.title}</h3>
							<p className="mt-1 text-xs leading-relaxed text-muted-foreground">{step.desc}</p>
						</div>);
    })}
			</div>
		</div>
	</section>);
